<template>
  <div class="widget-container">
    <el-select size="mini" style="width: 80px;" filterable v-model="date.yearSelect" placeholder="请选择" :class="{showDes:!showDes}" @change="forceUpdateYear" clearable @clear="forceUpdateYear">
      <el-option
          v-for="item in year"
          :key="item"
          :label="item"
          :value="item">
      </el-option>
    </el-select>
    <span v-show="showDes">年</span>
    <el-select size="mini" style="width: 80px;" filterable v-model="date.monthSelect" placeholder="请选择" :class="{showDes:!showDes}" @change="forceUpdateMonth" clearable @clear="forceUpdateMonth" :disabled=" date.yearSelect == '至今'">
      <el-option
          v-for="item in month"
          :key="item"
          :label="item"
          :value="item">
      </el-option>
    </el-select>
    <span v-show="showDes">月</span>
    <el-select size="mini" style="width: 80px;" filterable v-model="date.daySelect" placeholder="请选择" :class="{showDes:!showDes}" @change="forceUpdateDay" clearable @clear="forceUpdateDay" :disabled=" date.yearSelect == '至今'">
      <el-option
          v-for="item in day"
          :key="item"
          :label="item"
          :value="item">
      </el-option>
    </el-select>
    <span v-show="showDes">日</span>
  </div>
</template>

<script type="text/ecmascript-6">
import _ from 'lodash'
export default {
  name:'TimePicker',
  props:{
    isFuture: {
      default: false,
    },
    showDes:{
      type:Boolean,
      default:true
    },
    isDateCycle: {
      type: Boolean,
      default: false
    },
    value: {
    },
  },
  data() {
    return {
      date:{
          yearSelect:'',
          monthSelect:'',
          daySelect:''
      },
      valueAfter: this.value,
      monthHave:0,
      day:[],
      month:[]
    }
  },
  watch: {
    // valueAfter(val) {
    //   this.date = val
    // },
    valueAfter: {
      handler(val) {
        if(val) {
          this.date = val
        }
      },
      deep: true,
      immediate: true
    },
    value(val) {
      if(val) {
        this.valueAfter = val
      }else {
        this.valueAfter = {
          yearSelect:'',
          monthSelect:'',
          daySelect:''
        }
      }
      // this.$emit('input',val)
    }
  },

  computed:{
    year() {
      let start = 1930;
      let end = this.isFuture ? 2026 : new Date().getFullYear();
      // let end = 2026;

      let years = [];
      for (let i = start; i <= end; i++) {
        years.unshift(i)
      }
      if(this.isDateCycle) {
        years.unshift('至今')
      }
      years.unshift('不清楚')

      return years;
    },

  },
  components: {

  },
  mounted(){
    this.monthHave = this.getMonthHave()
    this.month = this.getMonth()
    this.day = this.getDays();
  },
  methods:{
    loadSelectData(){
      this.monthHave = this.getMonthHave()
      this.month = this.getMonth()
      this.day = this.getDays();
    },
    getMonthHave(){
      if(_.isNumber(parseInt(this.date.yearSelect,10))){
        if(_.isNaN(parseInt(this.date.monthSelect,10))){
          return 0;
        }else{
          if(parseInt(this.date.yearSelect,10) == new Date().getFullYear() && parseInt(this.date.monthSelect,10) == new Date().getMonth()+1){
            return new Date().getDate();
          }
          return new Date(this.date.yearSelect,this.date.monthSelect,0).getDate();
        }
      }
      return 0;
    },
    getDays () {
      let dayStart = 1
      let days = []
      for (let i = dayStart; i <= this.monthHave; i++) {
        days.unshift(i)
      }
      days.unshift('不清楚')
      if(this.date.yearSelect == '至今') {
        days.unshift('至今')
      }

      return days
    },
    getMonth () {
      let monthStart = 1
      let monthEnd = 12
      if (this.date.yearSelect == new Date().getFullYear() && !this.isFuture) {
          monthEnd = new Date().getMonth() + 1
      }
      let months = []
      for (let i = monthStart; i <= monthEnd; i++) {
        months.unshift(i)
      }
      if (this.date.yearSelect == new Date().getFullYear()) {
        let currentMonth = new Date().getMonth() + 1
        if (currentMonth > 6) {
          months.unshift('下半年')
        }
      } else {
        months.unshift('下半年')
      }
      if(this.date.yearSelect == '至今') {
        months.unshift('至今')
      }
      months.unshift('上半年')
      months.unshift('不清楚')

      return months
    },

    changeHandler() {
      this.$emit('input',this.date)
      // this.$emit('changeHandler')
    },
    forceUpdateYear() {
      this.monthHave = this.getMonthHave()
      this.month = this.getMonth()
      this.day = this.getDays();
      if(this.date.yearSelect == '至今') {
        this.date.monthSelect = '至今'
        this.date.daySelect = '至今'
      }
      // else if(this.date.yearSelect == '不清楚') {
      //   this.date.monthSelect = '不清楚'
      //   this.date.daySelect = '不清楚'
      //   this.date.hourSelect = '不清楚'
      //   this.date.minuteSelect = '不清楚'
      // }
      else {
        this.date.daySelect = ''
        this.date.monthSelect = ''
        this.date.hourSelect = ''
        this.date.minuteSelect = ''
      }
      this.changeHandler()
      this.$forceUpdate()
    },
    forceUpdateMonth() {
      this.monthHave = this.getMonthHave()
      this.day = this.getDays();
      this.date.daySelect = '';
      if(this.date.monthSelect == '不清楚' || this.date.monthSelect == '上半年' || this.date.monthSelect == '下半年') {
        this.date.daySelect = '不清楚'
        this.date.hourSelect = '不清楚'
        this.date.minuteSelect = '不清楚'
      }else {
        this.date.daySelect = ''
        this.date.hourSelect = ''
        this.date.minuteSelect = ''
      }
      this.changeHandler()
      this.$forceUpdate()
    },
    forceUpdateDay() {
      this.changeHandler()
      this.$forceUpdate()
    }
  },
  created(){
  }
}
</script>

<style scoped lang="scss">
.widget-container{
  &>.el-select{
    width:110px;
  }
  &>.el-select.showDes{
    margin-left:12px;
    margin-right:12px;
    &:nth-of-type(1){
      margin-left:25px;
    }
  }
}
</style>
